export default __webpack_public_path__ + "assets/fire-ea6ebe20716d001e78c5e8b2eae97e5c.svg";